export enum UploadResumeStep {
  UPLOAD_RESUME,
  RESUME_SELECTED,
  SENDING_RESUME,
  PARSED_DETAILS,
  USER_AVAILABLE,
}
